// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__KBnRB","bigColWidth":"Table_bigColWidth__2uBOS","biggerColWidth":"Table_biggerColWidth__1A9pp","row":"Table_row__1OVr-","col":"Table_col__1aRKS"};